<script setup>
import { computed } from 'vue'
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../../../core/config/constants.js'

const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: (v) => ['mobile', 'tablet', 'desktop'].includes(v),
  },
})

const variantClass = computed(() => `business-banner-${props.variant}`)
const showSubtitle = computed(() => props.variant !== 'mobile')
const showShape3 = computed(() => props.variant === 'desktop')
const showSparkle3 = computed(() => props.variant === 'desktop')
</script>

<template>
  <div class="business-banner" :class="variantClass">
    <div class="banner-bg-elements">
      <svg class="banner-shape banner-shape-1" viewBox="0 0 100 100" fill="none">
        <circle cx="50" cy="50" r="40" stroke="currentColor" stroke-width="2" opacity="0.3" />
        <circle
          v-if="variant === 'desktop'"
          cx="50"
          cy="50"
          r="25"
          stroke="currentColor"
          stroke-width="2"
          opacity="0.2"
        />
      </svg>
      <svg class="banner-shape banner-shape-2" viewBox="0 0 60 60" fill="none">
        <rect
          x="10"
          y="10"
          width="40"
          height="40"
          rx="8"
          stroke="currentColor"
          stroke-width="2"
          opacity="0.25"
          transform="rotate(15 30 30)"
        />
      </svg>
      <svg v-if="showShape3" class="banner-shape banner-shape-3" viewBox="0 0 80 80" fill="none">
        <polygon
          points="40,5 75,65 5,65"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
          opacity="0.2"
        />
      </svg>
      <div class="banner-sparkle banner-sparkle-1"></div>
      <div class="banner-sparkle banner-sparkle-2"></div>
      <div v-if="showSparkle3" class="banner-sparkle banner-sparkle-3"></div>
    </div>
    <div class="banner-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    </div>
    <h2 class="banner-title">הצטרפות בעלי עסקים</h2>
    <p v-if="showSubtitle" class="banner-subtitle">הצטרפו לרשת הספקים המובילה בישראל</p>
    <RouterLink :to="{ name: ROUTES.JOIN_NETWORK }" class="btn-banner">
      <span>לחץ כאן</span>
    </RouterLink>
  </div>
</template>

<style src="../styles/business-banner.css" scoped></style>
